export enum QueryParameter {
  subscriptionNumber = 'subNumber',
  week = 'week',
  showEditDeliveryDetails = 'showEditDeliveryDetails'
}
